<template>
    <div class="signup-type border-bottom-light row justify-content-sm-center">
        <div class="col-sm-6" v-if="types">
            <label class="full">I am...</label>
            <v-select 
                @input="updateType" 
                v-model="type" 
                :options="types"
                label="description">
            </v-select>
        </div>
    </div>
</template>

<script>
    import extendedVSelect from '@/extends/vue-select'
    import AccountType from '@/enums/accountType'

    export default {
        props: {
            chosenType: String,
        },
        data: function() {
            return {
                type: null,
            }
        },
        asyncComputed: {
            async types() {
                if (this.chosenType) {
                    const accountType = String(this.chosenType);
                    this.type = { id: AccountType.getAccountType(accountType), description: accountType };
                    this.updateType();
                    return null;
                }

                return [
                    { id: AccountType.Agent, description: 'Agent' },
                    { id: AccountType.Supplier, description: 'Supplier' }
                ];
            }
        },
        methods: {
            updateType: function() {
                this.$emit('typeChanged', this.type);
            }
        },
        components: {
            vSelect: extendedVSelect,
        }
    }
</script>

<style lang="scss" scoped>
    .signup-type { 
        margin-top: 2rem;
        margin-bottom: 3rem;
        padding-top: 2rem;
        padding-bottom: 3rem;
    }
</style>



// WEBPACK FOOTER //
// SignupType.vue?48847509